var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        "destroy-on-close": true,
        size: "960px",
        visible: _vm.dialogVisible,
        "before-close": _vm.beforeDrawCloseNotWithForm,
        "append-to-body": "",
        title: _vm.drawerTitle,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "div",
        { staticClass: "gwnl-related-items__wrap" },
        [
          _vm.setTabs.length === 2
            ? _c(
                "yxt-tabs",
                {
                  attrs: { "drawer-top": true },
                  on: { "tab-click": _vm.onTabClick },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                _vm._l(_vm.setTabs, function (tab) {
                  return _c("yxt-tab-pane", {
                    key: tab.value,
                    attrs: { label: tab.label, name: tab.value },
                  })
                }),
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "select-items__wraper flex",
              class: { mt24: _vm.setTabs.length === 2 },
            },
            [
              _c(
                "div",
                { staticClass: "related-table" },
                [
                  _vm.activeName === "ability"
                    ? _c("ability-selectors", {
                        ref: "ability",
                        attrs: {
                          limit: _vm.limit,
                          list: _vm.list,
                          identify: 0,
                          "get-skills": _vm.getSkills,
                        },
                        on: {
                          "update:list": function ($event) {
                            _vm.list = $event
                          },
                          update: _vm.updateList,
                          "update:selectedData":
                            _vm.setItemsNotInFormChangedStatus,
                        },
                      })
                    : _vm._e(),
                  _vm.activeName === "tasks"
                    ? _c("Tasks", {
                        ref: "tasks",
                        attrs: {
                          "is-single": _vm.isSingle,
                          limit: _vm.limit,
                          "rt-model-id": _vm.rtModelId,
                          projectId: _vm.projectId,
                          "selected-data": _vm.list,
                          "disabled-list": _vm.disabledList,
                          scene: _vm.scene,
                        },
                        on: { change: _vm.setTasks },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("check-list", {
                attrs: { list: _vm.list, source: _vm.source },
                on: { clear: _vm.clear, close: _vm.closeTag },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("yxt-button", { on: { click: _vm.close } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_comp_popconfirm_cancelButtonText")) +
                "\n    "
            ),
          ]),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("pc_biz_common_btn_sure")) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }